module.exports = __webpack_public_path__ + "media/landing_page/market_research-ad40df28.svg";